module.exports = __webpack_public_path__ + "media/news/karte_moeckern-94c66fe5.webp";